export const VossSubscriptionBillingPeriodKind = {
    NewPurchase: 0,
    Renewal: 1,
    NotBillable: 2
}